<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()"(dataExportToExcel)="exportToExcel()"  (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [showExportBtn]="showExportBtn" [showSearch]="showSearch" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Ticket Field</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
     <!-- <mat-radio-group (change)="onButtonChange($event)">
          <mat-radio-button *ngFor="let button of ttypes;" [value]="button.id" [checked]="button.checked">{{button.name}}</mat-radio-button>
      </mat-radio-group>-->
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onButtonChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of ttypes" [value]="ticket.id">{{ticket.name}}</option>
      </select>

    </div>
    <div class="row mar-lft-rgt-0">
      <div class="col-md-12 pad-15 category">
        <div class="height-40" [hidden]="categoryLoaded">
          <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;"
                (change)="onCategoryChange(ticket, $event.target.value)" id="ticket_{{ticket.id}}"
                [hidden]="!categoryLoaded">
          <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
        </select>
      </div>
    </div>
    <!--<div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
              (change)="onCategoryChange($event.target.selectedIndex)">
        <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
      </select>
    </div>-->
    <div *ngFor="let container of additionalField;">
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="container.name"
             placeholder="Description">
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="container.typeSelected"
              (change)="onTypeChange($event.target.selectedIndex)">
        <option *ngFor="let type of types" [value]="type.id">{{type.name}}</option>
      </select>
    </div>

    <div class="form-group" [hidden]="container.typeSelected !== '4'">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="container.dropdown" placeholder="Comma separated dropdown value">
    </div>
    <div class="form-group row font-13 font-weight-bold" [hidden]="container.typeSelected !== '1' && container.typeSelected !== '7'">
      <p class="col-sm-2 col-md-2">Is this a question ?</p>
      <mat-radio-group class="col-sm-2 col-md-2" [(ngModel)]="container.isQuestion">
        <mat-radio-button value="true">Yes</mat-radio-button>&nbsp;
        <mat-radio-button value="false">No</mat-radio-button>
      </mat-radio-group>
    </div>

    </div>
    <button (click)="addAdditionalFieldDiv()">Add more</button>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>



<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">

      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Field Name"
                 [(ngModel)]="fieldSelected"
                 matInput [formControl]="searchData"[matAutocomplete]="auto"
                >
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getDetails()">
              <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="50"></mat-spinner>
              </mat-option>
              <ng-container *ngIf="!isLoading">
                  <mat-option *ngFor="let field of fields" [value]="field.name">
                    {{ field.name }} 
                  </mat-option>
              </ng-container>
          </mat-autocomplete>
      </div>
    
      <div class="form-group">
          <input type="text" class="form-control radius-0 font-13" placeholder="Field Type" readonly
                 [(ngModel)]="ftype">
      </div>

  </div>
  <div class="modal-footer pad-8">
     
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  
      </div>

 

  </ng-template>
<notifier-container></notifier-container>
